import React from 'react';
import { useTranslation } from 'react-i18next';
import AnimatedLogo from './AnimatedLogo';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  const socialLinks = [
    { name: 'Twitter', icon: '🐦', url: '#' },
    { name: 'Telegram', icon: '📱', url: '#' },
    { name: 'GitHub', icon: '💻', url: '#' },
    { name: 'LinkedIn', icon: '💼', url: '#' }
  ];

  const footerLinks = [
    { name: t('footer.links.products'), url: '#products' },
    { name: t('footer.links.blog'), url: '#' },
    { name: t('footer.links.contact'), url: '#contact' },
    { name: t('footer.links.github'), url: '#' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <AnimatedLogo size="medium" className="logo-icon" />
              <span className="logo-text">
                <span className="company-name">Crypto Ocean</span>
                <span className="company-suffix"> Pty Ltd</span>
              </span>
            </div>
            <p className="footer-description">
              探索深海般广阔的 DeFi 世界，为交易者与投资者提供完整的链上工具生态。
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">快速链接</h4>
            <ul className="footer-links">
              {footerLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="footer-link">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">关注我们</h4>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="social-link"
                  title={social.name}
                >
                  <span className="social-icon">{social.icon}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <p className="footer-copyright">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 